import { useSearchParams } from "react-router-dom";
import classNames from "classnames";

import { BrieGPTTabs } from "./Types";

interface Props {
  tab: BrieGPTTabs;
  setTab: (tab: BrieGPTTabs) => void;
}

function TabStyles(isSelected: boolean) {
  return classNames(
    "tw:w-50 tw:text-center tw:text-sm tw:rounded tw:cursor-pointer tw:py-1",
    {
      "tw:bg-primary tw:font-semibold tw:text-white": isSelected,
    },
    {
      "tw:bg-superlight tw:font-medium": !isSelected,
    }
  );
}

export function BrieGPTTabNavigator({ tab, setTab }: Props) {
  const [params, setParams] = useSearchParams();

  function handleTabChange(newTab: BrieGPTTabs) {
    params.delete("projectID");
    params.delete("chatID");
    setParams(params);
    setTab(newTab);
  }

  return (
    <div className="tw:flex tw:gap-2 tw:px-2 tw:pt-2 tw:select-none">
      <div
        onClick={() => handleTabChange("Personal")}
        className={TabStyles(tab === "Personal")}
      >
        Personal
      </div>
      <div
        onClick={() => handleTabChange("Team")}
        className={TabStyles(tab === "Team")}
      >
        Team
      </div>
      <div
        onClick={() => handleTabChange("All")}
        className={TabStyles(tab === "All")}
      >
        All
      </div>
    </div>
  );
}
